import React from 'react';
import NO_AVA from 'styles/img/no-ava-card.png';
import {inject} from 'mobx-react';
import classnames from 'classnames';
import _ from 'lodash'
import moment from 'moment';
import WorkshopButtons from 'blocks/WorkshopButtons';
import {withRouter} from 'react-router-dom';
import EyeViewsComponent from 'blocks/EyeViewsComponent';
import HttpClient from "services/HttpClient";
import webinar_icon from 'styles/img/webinar_icon.jpg';
import {WORKSHOP_TYPES} from "stores/WorkshopsUrlConstants";
const COLOR = '#039ee5';



const CPD_FALSE = (<svg  width="10" height="9">
  <path fill="#FF524F" fillRule="evenodd" d="M2.292.758L.947 2.104l2.7 2.7-2.7 2.7L2.292 8.85l2.701-2.7 2.7 2.7 1.346-1.346-2.701-2.7 2.701-2.7L7.693.758l-2.7 2.701L2.292.758"/>
</svg>);


const CPD_TRUE = (<svg xmlns="http://www.w3.org/2000/svg" width="13" height="10">
  <path fill={COLOR} fillRule="evenodd"
        d="M10.753.82l1.556 1.571-7.26 7.333L.383 5.01l1.555-1.571 3.111 3.143L10.753.82z"/>
</svg>);

const Star = (<svg height="25" width="23" data-rating="1">
<polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" style={ { fillrule:'nonzero', fill: '#d8d8d8'}}/>
</svg>)

const Star_active = (<svg height="25" width="23" data-rating="1">
<polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" style={ { fillrule:'nonzero', fill: '#F2B00D'}}/>
</svg>)

const StarThree = (
  <svg height="25" viewBox="0 0 118 64" version="1.1">
      <title>stars-icon</title>
      <g id="WebApp" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-154.000000, -37.000000)">
              <g id="stars-icon" transform="translate(154.000000, 37.000000)">
                  <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" opacity="0" x="0.5" y="0.5" width="117" height="63"></rect>
                  <path d="M90.9327522,6.83731541 L96.7099957,20.4304597 L111.444223,21.7541448 C112.200485,21.8448377 112.862215,22.2270437 113.321988,22.7755201 C113.78391,23.3283151 114.041726,24.0495399 113.99446,24.8139519 L113.979421,24.9974971 C113.936451,25.342994 113.835473,25.6690567 113.687228,25.9648885 L113.618477,26.0879717 C113.491717,26.3103854 113.334879,26.5155242 113.156555,26.6947507 L101.924339,36.560847 L105.202909,50.9788653 C105.383381,51.760552 105.226542,52.5487169 104.831223,53.1792488 C104.438053,53.8054619 103.799956,54.2891576 103.020061,54.4662248 C102.635484,54.552599 102.242313,54.5590771 101.868479,54.492137 C101.505387,54.4273564 101.159483,54.291317 100.850103,54.0969749 L88.2643489,46.5370705 L82.3904241,50.0654578 L81.6105284,46.6947035 L87.4135536,43.207344 C87.9330633,42.889943 88.5846511,42.8874498 89.1065502,43.2008659 L101.801876,50.8277104 L98.506119,36.3384334 C98.3793591,35.7640448 98.5555339,35.1421503 99.0260495,34.727554 L110.165881,24.9521506 L95.5347811,23.6306249 C94.8947695,23.6124637 94.3240086,23.2210305 94.0738195,22.6286839 L88.2643489,8.95996209 L84.4099886,18.0335749 L80.968135,17.7226276 L85.5980941,6.82867798 C85.9096226,6.09017832 86.4918588,5.54818003 87.1793701,5.26962314 C87.8690299,4.9889069 88.6639648,4.97595076 89.400891,5.2912167 L89.5276509,5.35167866 C89.8284371,5.4963555 90.0948478,5.69069751 90.313992,5.91311115 C90.5782542,6.17007448 90.7845076,6.48965913 90.9327522,6.83731541 L90.9327522,6.83731541 Z M60.4802978,3.99128455 L68.3501539,22.514238 L88.3137638,24.3151407 C89.1946376,24.3907181 89.8477734,25.1702456 89.7704284,26.0555814 C89.7339043,26.4874526 89.5297994,26.8631805 89.2290132,27.1266219 L74.1273974,40.3807473 L78.5940725,60.0287251 C78.7938805,60.8946268 78.2524653,61.7605284 77.3887792,61.9591892 C76.9483423,62.0606789 76.5057569,61.9678266 76.1534073,61.7367755 L59,51.4280113 L41.7907324,61.7691659 C41.0323214,62.2247899 40.0504693,61.976464 39.5949931,61.2120521 C39.3815836,60.8571834 39.314513,60.4325753 39.4080759,60.0287251 L39.4059275,60.0265658 L43.874751,40.3807473 L28.7709868,27.1266219 C28.4508045,26.8457508 28.2549959,26.4483618 28.2267799,26.0221667 C28.1985638,25.5959717 28.3402602,25.1760114 28.6205937,24.8549796 C28.9050974,24.5285512 29.3087765,24.3315298 29.7399481,24.3086626 L49.6498461,22.514238 L57.5239991,3.98264713 C57.8720517,3.16209195 58.8130829,2.77988599 59.6273541,3.12970161 C60.0291185,3.30029072 60.3256078,3.61771601 60.4802978,3.99128455 L60.4802978,3.99128455 Z M29.7356511,8.95996209 L23.9261805,22.6286839 C23.6764704,23.221425 23.1054213,23.6130558 22.4652189,23.6306249 L7.83411873,24.9521506 L18.9739505,34.727554 C19.4286415,35.127674 19.6282919,35.7462427 19.493881,36.3384334 L16.2002721,50.8277104 L28.8934498,43.2008659 C29.4327164,42.8769626 30.0815552,42.9007155 30.5864464,43.207344 L36.3980655,46.6990222 L35.6310607,50.0784139 L29.7356511,46.5370705 L17.1498971,54.0991343 C16.840517,54.291317 16.4946129,54.4273564 16.1315209,54.492137 C15.7576867,54.5590771 15.3645161,54.552599 14.982088,54.4662248 C14.1978954,54.2891576 13.5619474,53.8054619 13.1687769,53.1792488 C12.7756063,52.5465575 12.6187678,51.760552 12.7970911,50.9788653 L16.0756606,36.560847 L4.84344451,26.6947507 C4.66512126,26.5155242 4.50828274,26.3103854 4.38152284,26.0879717 L4.31492018,25.9648885 C4.16452708,25.6690567 4.06354886,25.342994 4.0205794,24.9974971 L4.00554009,24.8204299 C3.95827369,24.0516993 4.21609043,23.3304745 4.6780121,22.7755201 C5.13778529,22.2248843 5.79951493,21.8448377 6.55792585,21.7541448 L21.2900043,20.4304597 L27.0672478,6.83731541 C27.2154924,6.48965913 27.4238943,6.17007448 27.6817111,5.9109518 C27.9051522,5.69069751 28.1694144,5.49851485 28.4702006,5.35383802 L28.6012574,5.2912167 C29.3338867,4.97595076 30.1309701,4.9889069 30.8206299,5.26746379 C31.5081412,5.54818003 32.0903774,6.09017832 32.4019059,6.82867798 L37.0297165,17.7183089 L33.5921599,18.0292562 L29.7356511,8.95996209 L29.7356511,8.95996209 Z" id="Shape" fill="#d8d8d8"></path>
              </g>
          </g>
      </g>
  </svg>
);


const StarThreeActive = (
  <svg height="25" viewBox="0 0 118 64" version="1.1">
      <title>stars-icon</title>
      <g id="WebApp" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-154.000000, -37.000000)">
              <g id="stars-icon" transform="translate(154.000000, 37.000000)">
                  <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" opacity="0" x="0.5" y="0.5" width="117" height="63"></rect>
                  <path d="M90.9327522,6.83731541 L96.7099957,20.4304597 L111.444223,21.7541448 C112.200485,21.8448377 112.862215,22.2270437 113.321988,22.7755201 C113.78391,23.3283151 114.041726,24.0495399 113.99446,24.8139519 L113.979421,24.9974971 C113.936451,25.342994 113.835473,25.6690567 113.687228,25.9648885 L113.618477,26.0879717 C113.491717,26.3103854 113.334879,26.5155242 113.156555,26.6947507 L101.924339,36.560847 L105.202909,50.9788653 C105.383381,51.760552 105.226542,52.5487169 104.831223,53.1792488 C104.438053,53.8054619 103.799956,54.2891576 103.020061,54.4662248 C102.635484,54.552599 102.242313,54.5590771 101.868479,54.492137 C101.505387,54.4273564 101.159483,54.291317 100.850103,54.0969749 L88.2643489,46.5370705 L82.3904241,50.0654578 L81.6105284,46.6947035 L87.4135536,43.207344 C87.9330633,42.889943 88.5846511,42.8874498 89.1065502,43.2008659 L101.801876,50.8277104 L98.506119,36.3384334 C98.3793591,35.7640448 98.5555339,35.1421503 99.0260495,34.727554 L110.165881,24.9521506 L95.5347811,23.6306249 C94.8947695,23.6124637 94.3240086,23.2210305 94.0738195,22.6286839 L88.2643489,8.95996209 L84.4099886,18.0335749 L80.968135,17.7226276 L85.5980941,6.82867798 C85.9096226,6.09017832 86.4918588,5.54818003 87.1793701,5.26962314 C87.8690299,4.9889069 88.6639648,4.97595076 89.400891,5.2912167 L89.5276509,5.35167866 C89.8284371,5.4963555 90.0948478,5.69069751 90.313992,5.91311115 C90.5782542,6.17007448 90.7845076,6.48965913 90.9327522,6.83731541 L90.9327522,6.83731541 Z M60.4802978,3.99128455 L68.3501539,22.514238 L88.3137638,24.3151407 C89.1946376,24.3907181 89.8477734,25.1702456 89.7704284,26.0555814 C89.7339043,26.4874526 89.5297994,26.8631805 89.2290132,27.1266219 L74.1273974,40.3807473 L78.5940725,60.0287251 C78.7938805,60.8946268 78.2524653,61.7605284 77.3887792,61.9591892 C76.9483423,62.0606789 76.5057569,61.9678266 76.1534073,61.7367755 L59,51.4280113 L41.7907324,61.7691659 C41.0323214,62.2247899 40.0504693,61.976464 39.5949931,61.2120521 C39.3815836,60.8571834 39.314513,60.4325753 39.4080759,60.0287251 L39.4059275,60.0265658 L43.874751,40.3807473 L28.7709868,27.1266219 C28.4508045,26.8457508 28.2549959,26.4483618 28.2267799,26.0221667 C28.1985638,25.5959717 28.3402602,25.1760114 28.6205937,24.8549796 C28.9050974,24.5285512 29.3087765,24.3315298 29.7399481,24.3086626 L49.6498461,22.514238 L57.5239991,3.98264713 C57.8720517,3.16209195 58.8130829,2.77988599 59.6273541,3.12970161 C60.0291185,3.30029072 60.3256078,3.61771601 60.4802978,3.99128455 L60.4802978,3.99128455 Z M29.7356511,8.95996209 L23.9261805,22.6286839 C23.6764704,23.221425 23.1054213,23.6130558 22.4652189,23.6306249 L7.83411873,24.9521506 L18.9739505,34.727554 C19.4286415,35.127674 19.6282919,35.7462427 19.493881,36.3384334 L16.2002721,50.8277104 L28.8934498,43.2008659 C29.4327164,42.8769626 30.0815552,42.9007155 30.5864464,43.207344 L36.3980655,46.6990222 L35.6310607,50.0784139 L29.7356511,46.5370705 L17.1498971,54.0991343 C16.840517,54.291317 16.4946129,54.4273564 16.1315209,54.492137 C15.7576867,54.5590771 15.3645161,54.552599 14.982088,54.4662248 C14.1978954,54.2891576 13.5619474,53.8054619 13.1687769,53.1792488 C12.7756063,52.5465575 12.6187678,51.760552 12.7970911,50.9788653 L16.0756606,36.560847 L4.84344451,26.6947507 C4.66512126,26.5155242 4.50828274,26.3103854 4.38152284,26.0879717 L4.31492018,25.9648885 C4.16452708,25.6690567 4.06354886,25.342994 4.0205794,24.9974971 L4.00554009,24.8204299 C3.95827369,24.0516993 4.21609043,23.3304745 4.6780121,22.7755201 C5.13778529,22.2248843 5.79951493,21.8448377 6.55792585,21.7541448 L21.2900043,20.4304597 L27.0672478,6.83731541 C27.2154924,6.48965913 27.4238943,6.17007448 27.6817111,5.9109518 C27.9051522,5.69069751 28.1694144,5.49851485 28.4702006,5.35383802 L28.6012574,5.2912167 C29.3338867,4.97595076 30.1309701,4.9889069 30.8206299,5.26746379 C31.5081412,5.54818003 32.0903774,6.09017832 32.4019059,6.82867798 L37.0297165,17.7183089 L33.5921599,18.0292562 L29.7356511,8.95996209 L29.7356511,8.95996209 Z" id="Shape" fill="#1EA2E8"></path>
              </g>
          </g>
      </g>
  </svg>
);

const StarTen = (
  <svg width="25" height="25" viewBox="0 0 64 64">
      <title>black-star-icon</title>
      <g id="WebApp" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-70.000000, -37.000000)">
              <g id="black-star-icon" transform="translate(70.000000, 37.000000)">
                  <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" opacity="0" x="0.5" y="0.5" width="63" height="63"></rect>
                  <path d="M33.4789505,2.98719466 L41.4081977,21.5017503 L61.5289146,23.2998179 C62.1719162,23.3569554 62.7189835,23.7911474 62.9198266,24.403746 C63.1206697,25.0163445 62.9366567,25.6895172 62.4519758,26.1152794 L62.4519758,26.1152794 L47.2239878,39.3766573 L51.7232807,59.0194122 C51.8721744,59.660747 51.6154645,60.3280354 51.0748634,60.7048999 C50.5342623,61.0817644 49.818457,61.092437 49.2668282,60.7318575 L31.9909556,50.4269661 L14.6646426,60.7721504 C14.1098127,61.1028896 13.4109102,61.0713444 12.8882263,60.6919712 C12.3655424,60.3125981 12.1198226,59.6585196 12.2636746,59.0294854 L12.2636746,59.0294854 L16.7629675,39.3867305 L1.5501116,26.1152794 C1.05849934,25.6849229 0.875431606,25.0009508 1.0864816,24.383079 C1.29753159,23.7652072 1.86101032,23.3354848 2.51352522,23.2947813 L22.5585814,21.5017503 L30.5029608,2.98719466 C30.7547438,2.3890596 31.3411719,2 31.9909556,2 C32.6407394,2 33.2271675,2.3890596 33.4789505,2.98719466 Z" id="Path" fill="#d8d8d8" fill-rule="nonzero"></path>
              </g>
          </g>
      </g>
  </svg>
);

const StarTenActive = (
  <svg width="25" height="25" viewBox="0 0 64 64">
      <title>black-star-icon</title>
      <g id="WebApp" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-70.000000, -37.000000)">
              <g id="black-star-icon" transform="translate(70.000000, 37.000000)">
                  <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" opacity="0" x="0.5" y="0.5" width="63" height="63"></rect>
                  <path d="M33.4789505,2.98719466 L41.4081977,21.5017503 L61.5289146,23.2998179 C62.1719162,23.3569554 62.7189835,23.7911474 62.9198266,24.403746 C63.1206697,25.0163445 62.9366567,25.6895172 62.4519758,26.1152794 L62.4519758,26.1152794 L47.2239878,39.3766573 L51.7232807,59.0194122 C51.8721744,59.660747 51.6154645,60.3280354 51.0748634,60.7048999 C50.5342623,61.0817644 49.818457,61.092437 49.2668282,60.7318575 L31.9909556,50.4269661 L14.6646426,60.7721504 C14.1098127,61.1028896 13.4109102,61.0713444 12.8882263,60.6919712 C12.3655424,60.3125981 12.1198226,59.6585196 12.2636746,59.0294854 L12.2636746,59.0294854 L16.7629675,39.3867305 L1.5501116,26.1152794 C1.05849934,25.6849229 0.875431606,25.0009508 1.0864816,24.383079 C1.29753159,23.7652072 1.86101032,23.3354848 2.51352522,23.2947813 L22.5585814,21.5017503 L30.5029608,2.98719466 C30.7547438,2.3890596 31.3411719,2 31.9909556,2 C32.6407394,2 33.2271675,2.3890596 33.4789505,2.98719466 Z" id="Path" fill="#1EA2E8" fill-rule="nonzero"></path>
              </g>
          </g>
      </g>
  </svg>
);


@inject('user')
@withRouter
export default class OnlineWorkShop extends React.Component {


  handleDelete = () => {
    this.props.handleDelete(this.props.workshop.id)
  };

  redirect = () => {
    let user = this.props.user.getUser();
    if(user && this.props.workshop.created_by === user.id) {
      switch(this.props.workshop.workshop_type) {
        case 'group_supervision':
          this.props.history.push('/provider/my_public_webinars/' + this.props.workshop.id);
          break;
        case 'public_workshop':
          this.props.history.push('/provider/my_public_workshops/' + this.props.workshop.id);
          break;
        case 'online':
          this.props.history.push('/provider/my_workshop/' + this.props.workshop.id);
          break;
        case 'live':
          this.props.history.push('/provider/my_webinar/' + this.props.workshop.id);
          break;
        case 'organization':
          this.props.history.push('/provider/org/' + this.props.workshop.id);
          break;
        default:
          this.props.history.push('/provider/my_workshop/' + this.props.workshop.id);
          break;
      }
      // this.props.history.push('/provider/my_workshop/' + this.props.workshop.id);
    } else if(user && user.role === 'admin')
      this.props.history.push('/admin/details/' + this.props.workshop.id);
    else {
      switch(this.props.workshop.workshop_type) {
        case 'group_supervision':
          this.props.history.push('/details/public_webinars/' + this.props.workshop.id);
          break;
        case 'public_workshop':
          this.props.history.push('/details/public_workshops/' + this.props.workshop.id);
          break;
        case 'online':
          this.props.history.push('/details/online/' + this.props.workshop.id);
          break;
        case 'live':
          this.props.history.push('/details/webinar/' + this.props.workshop.id);
          break;
        case 'organization':
          this.props.history.push('/provider/org/' + this.props.workshop.id);
          break;
        default:
          this.props.history.push('/details/online/' + this.props.workshop.id);
          break;
      }
    }
  };

  handleFixToTop = workshop =>{
    const workshop_id = workshop.id;
    const {is_fixed} = workshop;
    const formData = new FormData();
    formData.append("workshop_id", workshop_id);
    formData.append("workshop_type", WORKSHOP_TYPES[workshop.workshop_type]);
    formData.append("is_fixed", !is_fixed)
    new HttpClient()
          .multipart("/api/v1/workshops/change_fixed_status", formData, "POST")
          .then(data => {
            if (data.status == '200'){
              window.location.reload();
            } else if (data.error.error_message == 'Invalid fixed workshops count'){
              alert('Only 3 workshops can be fixed');
            }
          })
  }

  handleStarToTop = workshop =>{
    const workshop_id = workshop.id;
    const {is_stared} = workshop;
    const formData = new FormData();
    formData.append("workshop_id", workshop_id);
    formData.append("workshop_type", WORKSHOP_TYPES[workshop.workshop_type]);
    formData.append("is_stared", !is_stared)
    new HttpClient()
          .multipart("/api/v1/workshops/change_fixed_status", formData, "POST")
          .then(data => {
            if (data.status == '200'){
              window.location.reload();
            } else if (data.error.error_message == 'Invalid fixed workshops count'){
              alert('Only 3 workshops can be fixed');
            }
          })
  }

  prepareContentForDiscription = () => {
    if (this.props.workshop.summary)
      return (<p className="card-desc" style={{flex: 1}}>{ this.props.workshop.summary }</p>)

    return (<p className="card-desc" style={{flex: 1}} dangerouslySetInnerHTML={{__html: this.props.workshop.short_description}}/>)
  };

  checkAccess = workshop => {
    return workshop.with_access_code ? 'Restricted Access – Free' : 'FREE';
  }

  getLiveTitle = type => {
    switch(type) {
      case 'group_supervision':
        return 'Public Webinars';
      case 'public_workshop':
        return 'Public Workshops';
      case 'live':
        return 'Live';
      case 'organization':
        return 'Organisation';
      default:
        return '';
    }
  }

  getStatus = status => {
    switch(status) {
      case 'workshop_completed':
        return 'Completed';
      case 'workshop_not_started':
        return 'Incomplete';
      case 'workshop_trainee_progress':
        return 'In Progress';
      case 'workshop_check_response':
        return 'Incomplete';
      default:
        return '';
    }
  }

  render() {
    let user = this.props.user.getUser();
    let workshop = this.props.workshop;
    const isWebinar = this.props.isWebinar;
    const showStatus = user && workshop.created_by !== user.id && user.role !== 'admin' && workshop.status;
    // if(user_id)
    //   user_id = user_id.id;
    return(
      <section className="card regular workshop-card list-workshops">
        <div className="card-avatar-wrap" onClick={this.redirect}>
          <div className="card-avatar-wrap-inner">
            {workshop.provider_logo_url ?
              <img src={workshop.provider_logo_url} alt="ava" className="has-ava"/> :
              <img src={NO_AVA} alt="ava"/> }
          </div>
          <p className="provide">PROVIDED BY</p>
          <p className="name"> {workshop.provided_by}</p>
        </div>
        <div className="card-content-wrap">
          { user && user.role == 'admin' ?
            <div
              onClick={e => {
                e.stopPropagation();
                this.handleFixToTop(workshop)
              }}
              className="star"
            >
              {workshop.is_fixed ? StarThreeActive : StarThree}
            </div> : null
          }
          { user && user.role == 'admin' ?
            <div
              onClick={e => {
                e.stopPropagation();
                this.handleStarToTop(workshop)
              }}
              className="starTen"
            >
              {workshop.is_stared ? StarTenActive : StarTen}
            </div> : null
          }
          <div onClick={this.redirect}>
            <div className="card-head">
                <p className="card-title" style={{color: COLOR, width: '65%'}}>{workshop.title}</p>
                {showStatus && (
                  <span
                    className={classnames('list-workshops-status', {
                      completed: workshop.status === 'workshop_completed' || workshop.status === 'workshop_check_response'
                    })}
                  >
                    {this.getStatus(workshop.status)}
                  </span>
                )}
                {isWebinar ?
                  <div style={{display: 'flex', alignItems: 'center', alignSelf: 'flex-start'}}>
                    <p className={(workshop.workshop_type === 'group_supervision' || workshop.workshop_type === 'organization') ? "group_supervision" : ""} style={(workshop.workshop_type === 'group_supervision' || workshop.workshop_type === 'organization') ? {
                      marginLeft: '-70px'
                    } : {}}>{this.getLiveTitle(workshop.workshop_type)}</p>
                    <img src={webinar_icon} style={{width: '25px', marginLeft: '5px'}} />
                  </div> : null
                }
              <EyeViewsComponent count={workshop.views_count}
                                online={true}/>
              </div>
            <div className="card-content" style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
              {this.prepareContentForDiscription()}
              {workshop.start_date ?
                <span className="regular-workshop-venue-data-holder" style={{maxHeight: '25px', flex: 1, textAlign: 'center'}}>
                  <span className="date">{`${moment(workshop.start_date).format('D MMM`YY')} - ${moment(workshop.end_date).format('D MMM`YY')}`}</span>
                  <span className="time" style={{marginLeft: 3}}>
                    {workshop.start_time &&
                      [moment(workshop.start_time).format('HH:mm'), '-']
                    }

                    {workshop.end_time &&
                      moment(workshop.end_time).format('HH:mm')
                    } </span>
                </span>
                // <span className="card-head-date">
                //   {moment(workshop.start_date).format("D MMM`YY")}
                // </span>
                : null
              }
            </div>
          </div>
          <div className="card-footer">

            <div className="card-footer-bottom">
              <ul className="card-info">
                <li>
                  <ul className="suitableFor">
                    <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                    {_.sortBy(workshop.target_audience).map( (el,i) =>
                      <li key={i}><span style={{color: COLOR, marginLeft: 1}}>{el}</span></li>
                    )}
                  </ul>
                </li>
                <li>
                  <p className="card-info-title" key="info">
                    CPD Hours:
                    <span className="card-info-sub">
                      {/* {workshop.cpd_hours ? workshop.how_many_hours : 'Check with provider'} */}
                      {workshop.cpd_hours ? workshop.how_many_hours : 'No'}
                    </span>
                  </p>
                </li>
                <li>
                  <p className="card-info-title" key="modules">
                    Modules:
                    <span className="card-info-sub" style={{color: COLOR}}>
                      {workshop.modules_count || 0}
                    </span>
                  </p>
                </li>
                <li>
                  <p className="card-info-title" key="cost">
                    PRICE:
                    <span className="card-info-sub" style={{color: COLOR}}>
                      {parseFloat(workshop.cost)  ? [<span className="currency euro" key="pound"/>, workshop.cost ] : this.checkAccess(workshop)  }
                    </span>
                  </p>
                </li>
              </ul>
              <WorkshopButtons
                owner={user && workshop.created_by === user.id}
                emptyUser={!user}
                admin={user && user.role === 'admin'}
                type={workshop.workshop_type}
                id={workshop.id}
                handleDelete={this.handleDelete}
                handleDetails={this.redirect}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/OnlineWorkShop.jsx